import { Box, Tab, Tabs, tabsClasses, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import DropDown from './dropDown';
import HeaderChild from './headerList';
import GSTDropDown from './gstDropDown';
import { useThemes } from '../../../../components/Theme/theme';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import InventoryDropDown from './InventoryDropDown';

const Header = ({
  data,
  setSelectedTab,
  selectedTab,
  setBackdropOpen,
  backdropOpen,
  setGSTData,
  includeOpeningBalance,
  list,
  loading,
  setTableData,
  selectedAccount,
  tableData,
  setSelectedAccount,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const openPopover = Boolean(anchorEl);
  const { theme } = useThemes();
  const smallScreen = useMediaQuery(theme.breakpoints.down('lg'));

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
      {smallScreen ? (
        <Box
          sx={{
            width: '100%',
            marginTop: '5px',
            borderRadius: '10px',
            overflow: 'auto',
            display: 'flex',
            justifyContent: 'space-around',
          }}
        >
          <Tabs
            aria-label="basic tabs example"
            variant={smallScreen ? 'scrollable' : 'fullWidth'}
            scrollButtons="auto"
            allowScrollButtonsMobile
            value={selectedTab}
            onChange={(event, newValue) => {
              setSelectedTab((prev) => {
                console.log(prev, 'prev');

                return newValue;
              });
              setAnchorEl(event.currentTarget);
            }}
            sx={{
              [`& .${tabsClasses.scrollButtons}`]: {
                '&.Mui-disabled': { opacity: 0.3 },
              },
              '& .MuiTab-root': {
                fontWeight: 'bold',
                fontSize: '14px',
                color: theme.palette.text.textClr,
                textTransform: 'none',
              },
              '& .Mui-selected': {
                color: theme.palette.sideBar.main,
                fontSize: '15px',
              },
              borderRadius: '10px',
              transition: 'all 1s ease-in-out',
            }}
          >
            {data.map((dat) => {
              return (
                <Tab
                  label={
                    <Box display="flex" alignItems="center">
                      {dat.label}
                      {[1, 2, 3, 5, 6, 7, 9].includes(dat.id) && <ArrowDropDownIcon />}
                    </Box>
                  }
                  value={dat.id}
                  onClick={(event, newValue) => {
                    setSelectedTab((prev) => {
                      console.log(prev, 'prev');
                      if (
                        (prev !== 1 && prev !== 2 && prev !== 3 && (dat.id == 1 || dat.id == 2 || dat.id == 3)) ||
                        ((prev == 1 || prev == 2 || prev == 3) && dat.id != 1 && dat.id != 2 && dat.id && 3)
                      ) {
                        setSelectedAccount([]);
                        setTableData([]);
                      }

                      return dat.id;
                    });
                    setAnchorEl(event.currentTarget);
                  }}
                >
                  {' '}
                </Tab>
              );
            })}
          </Tabs>
        </Box>
      ) : (
        data.map((dat) => {
          return (
            <HeaderChild
              key={dat.id}
              setSelectedTab={setSelectedTab}
              dat={dat}
              selectedTab={selectedTab}
              setAnchorEl={setAnchorEl}
              setSelectedAccount={setSelectedAccount}
              setTableData={setTableData}
            />
          );
        })
      )}

      {[1, 2, 3, 5, 7].includes(selectedTab) ? (
        <DropDown
          handleClose={handleClose}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          openPopover={openPopover}
          backdropOpen={backdropOpen}
          setBackdropOpen={setBackdropOpen}
          list={list}
          loading={loading}
          includeOpeningBalance={includeOpeningBalance}
          setTableData={setTableData}
          selectedTab={selectedTab}
          tableData={tableData}
          setSelectedAccount={setSelectedAccount}
          selectedAccount={selectedAccount}
        />
      ) : null}
      {selectedTab === 6 && (
        <GSTDropDown
          handleClose={handleClose}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          openPopover={openPopover}
          list={list}
          setBackdropOpen={setBackdropOpen}
          setGSTData={setGSTData}
          selectedTab={selectedTab}
          setSelectedAccount={setSelectedAccount}
          selectedAccount={selectedAccount}
        />
      )}
      {selectedTab === 9 && (
        <InventoryDropDown
          handleClose={handleClose}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          openPopover={openPopover}
          list={list}
          setBackdropOpen={setBackdropOpen}
          setGSTData={setGSTData}
          selectedTab={selectedTab}
          setSelectedAccount={setSelectedAccount}
          selectedAccount={selectedAccount}
        />
      )}
    </Box>
  );
};
export default Header;
